import ApiService from './api.service.js'

const mngServices = {
  getAllManagedServices: async function (data, callback) {
    try {
      let params = {
        params: {
          action: 'managed-services',
          size:10
        }
      }
      console.log('data',data)
      if (data.nextPaginationKey !== undefined) {
        params['params']['nextPaginationKey'] = data.nextPaginationKey
      }
      console.log('getAllManagedServices', params)
      let custResponse = await ApiService.get(process.env.VUE_APP_MANAGE_SERVICES_API, params)
      callback(custResponse.data)
    } catch (error) {
      throw new Error('Error: ' + error)
    }
  },
  addManagedServices: async function (data, callback) {
    console.log('addManagedServices data', data)
    data['Requestor_Id'] = vm.$store.state.currentUser.requestor_id
    try {
      let params = {
        action: 'managed-services',
        ...data
      }
      console.log('addManagedServices', params)
      let addResponse = await ApiService.post(process.env.VUE_APP_MANAGE_SERVICES_API, data)
      callback(addResponse.data)
    } catch (error) {
      throw new Error('Error: ' + error)
    }
  },
  approveManagedServices: async function (data, callback) {
    console.log('approveManagedServices data', data)
    try {
      let params = {
        action: 'managed-services',
        Approved_By: vm.$store.state.currentUser.email,
        Status: 'Approved',
        Managed_Services_Id: data.Managed_Services_Id
      }
      console.log('approveManagedServices', params)
      let addResponse = await ApiService.put(process.env.VUE_APP_MANAGE_SERVICES_API, params)
      callback(addResponse)
    } catch (error) {
      throw new Error('Error: ' + error)
    }
  }
}

export default mngServices
